import React, { useState } from 'react';
import { Code, Users, Lightbulb } from 'lucide-react';
import { skills } from '../data/mock';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const Skills = () => {
  const [activeTab, setActiveTab] = useState('executive');

  const renderSkillBar = (skill) => (
    <div key={skill.name} className="mb-6 last:mb-0">
      <div className="flex justify-between items-center mb-2">
        <span className="text-white font-medium">{skill.name}</span>
        <span className="text-gray-500 text-sm font-mono">{skill.level}%</span>
      </div>
      <div className="w-full bg-gray-900 rounded-full h-2 overflow-hidden">
        <div
          className="bg-white h-full rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${skill.level}%` }}
        ></div>
      </div>
    </div>
  );

  return (
    <section id="skills" className="py-24 bg-black relative">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm font-mono tracking-wider uppercase">Expertise</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              Skills & Competencies
            </h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
          </div>

          {/* Skills Tabs */}
          <Tabs defaultValue="executive" className="w-full">
            <TabsList className="grid w-full grid-cols-3 bg-gray-950 border border-gray-800 p-1 rounded-lg mb-12">
              <TabsTrigger 
                value="executive" 
                className="data-[state=active]:bg-white data-[state=active]:text-black text-gray-400 rounded-md transition-all"
              >
                <Users className="w-4 h-4 mr-2" />
                Executive Search
              </TabsTrigger>
              <TabsTrigger 
                value="technical" 
                className="data-[state=active]:bg-white data-[state=active]:text-black text-gray-400 rounded-md transition-all"
              >
                <Code className="w-4 h-4 mr-2" />
                Technical
              </TabsTrigger>
              <TabsTrigger 
                value="soft" 
                className="data-[state=active]:bg-white data-[state=active]:text-black text-gray-400 rounded-md transition-all"
              >
                <Lightbulb className="w-4 h-4 mr-2" />
                Soft Skills
              </TabsTrigger>
            </TabsList>

            <TabsContent value="executive" className="mt-0">
              <div className="bg-gray-950 border border-gray-800 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Executive Search & Recruitment</h3>
                <div className="space-y-6">
                  {skills.executive.map(renderSkillBar)}
                </div>
              </div>
            </TabsContent>

            <TabsContent value="technical" className="mt-0">
              <div className="bg-gray-950 border border-gray-800 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Technical & Development Skills</h3>
                <div className="space-y-6">
                  {skills.technical.map(renderSkillBar)}
                </div>
              </div>
            </TabsContent>

            <TabsContent value="soft" className="mt-0">
              <div className="bg-gray-950 border border-gray-800 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Soft Skills & Leadership</h3>
                <div className="space-y-6">
                  {skills.soft.map(renderSkillBar)}
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </section>
  );
};

export default Skills;
